import Nullstack from 'nullstack';
export default function IconGenderGenderfluid({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-gender-genderfluid",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 15.464a4 4 0 1 0 4 -6.928a4 4 0 0 0 -4 6.928z"
  }), "   ", Nullstack.element("path", {
    d: "M15.464 13.999l3 -5.196"
  }), "   ", Nullstack.element("path", {
    d: "M5.536 15.195l3 -5.196"
  }), "   ", Nullstack.element("path", {
    d: "M12 12h.01"
  }), "   ", Nullstack.element("path", {
    d: "M9 9l-6 -6"
  }), "   ", Nullstack.element("path", {
    d: "M5.5 8.5l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M21 21l-6 -6"
  }), "   ", Nullstack.element("path", {
    d: "M17 20l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M3 7v-4h4"
  }), " ");
}